import { getFeature } from 'Cloud/Application/FeaturesEs6';

type FeatureQuotaBuyWebviewConfig = {
    start?: number;
    end?: number;
};

/* Включение оплаты для вебвью IOS облака */
export const quotaBuyWebviewIOSConfig: FeatureQuotaBuyWebviewConfig = getFeature('quota-buy-ios-config-webview-cloud');
/* Включение оплаты для вебвью IOS почты */
export const quotaBuyIOSConfig: FeatureQuotaBuyWebviewConfig = getFeature('quota-buy-ios-config');
/* Включение оплаты для вебвью Android почты */
export const quotaBuyAndroidConfig: FeatureQuotaBuyWebviewConfig = getFeature('quota-buy-android-config');
